// src/Status.jsx
import React, { useEffect, useState } from "react";
import Box from '@mui/material/Box';

function Stats() {
  const [stats, setStats] = useState(null);

//   useEffect(() => {
//     // visit count POST
//     fetch("/api/stats/visit", { method: "POST" }).catch(() => {});

//     // stats get
//     fetch("/api/stats")
//       .then((res) => res.json())
//       .then(setStats)
//       .catch((err) => {
//         console.error("Stats fetch error", err);
//       });
//   }, []);

useEffect(() => {
  // visit count POST
  fetch(`${process.env.REACT_APP_API_URL}/api/stats/visit`, { method: "POST" })
    .catch(() => {});

  // stats get
  fetch(`${process.env.REACT_APP_API_URL}/api/stats`)
    .then((res) => res.json())
    .then((data) => {
      console.log("Stats from server:", data);
      setStats(data);
    })
    .catch((err) => {
      console.error("Stats fetch error", err); 
    });
}, []);



  return (
    // <div style={{ padding: "20px", fontFamily: "sans-serif" }}>
    //   <h2>App Status</h2>

    //   {!stats && <p>Loading...</p>}

    //   {stats && (
    //     <div>
    //       <p>Total Visits: {stats.totalVisits}</p>
    //       <p>Total Generations: {stats.totalGenerations}</p>
    //       <p>Total PDF Downloads: {stats.totalPdfDownloads}</p>
    //     </div>
    //   )}
    // </div>

     <div
    style={{
      height: "90vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
     // background: "#111",
     // color: "white",
      fontFamily: "Poppins, sans-serif",
    }}
  >
    <div
      style={{
        width: "340px",
        padding: "25px 30px",
        textAlign: "center",
        borderRadius: "15px",
        backdropFilter: "blur(8px)",
        background: "rgba(255,255,255,0.08)",
        border: "1px solid rgba(255,255,255,0.2)",
        boxShadow: "0 0 25px rgba(0,0,0,0.5)",
        fontFamily: "Poppins, sans-serif",
      }}
    >
      <h2 style={{ marginBottom: "28px" }}> App Status</h2>

      {!stats && <p>Loading...</p>}

      {stats && (
        <>
         <Box component="section" sx={{  p: 1, border: 0, borderRadius: 2 , mb: 2,bgcolor:"black",color:"white"  }}>
          
          <div style={{ fontSize: "28px", fontWeight: "bold" }}>
            {stats.totalVisits}
          </div>
          <div style={{ opacity: 0.7, marginBottom: "5px" }}>Visiters</div> 
          </Box>
          <Box component="section" sx={{  p: 1, border: 0, borderRadius: 2, mb: 2,bgcolor:"black",color:"white"   }}>
          <div style={{ fontSize: "28px", fontWeight: "bold" }}>
            {stats.totalGenerations}
          </div>
          
           
          <div style={{ opacity: 0.7, marginBottom: "5px" }}>
            Total Generations
          </div>
          </Box>
<Box component="section" sx={{ p: 1, border: 0, borderRadius: 2 , mb: 2 ,bgcolor:"black",color:"white"}}>
          <div style={{ fontSize: "28px", fontWeight: "bold" }}>
            {stats.totalPdfDownloads}
          </div>
          <div style={{ opacity: 0.7, marginBottom: "5px"  }}>PDF Downloads</div>
        </Box>
        </>
      )}
    </div>
  </div>
  );
}

export default Stats;
